import React, { ReactNode, useMemo, useRef, useState } from "react";
import List from "@/components/List";
import { View } from "@tarojs/components";
import classNames from "classnames";
import type { XHListProps } from "../List";

import "./index.scss";

export type CollapseProps = {
  summary?: string | ReactNode;
  open?: boolean;
  style?: React.CSSProperties;
  onToggle?: (open: boolean) => void;
  dataTrackId?: string;
} & XHListProps;

const Collapse: React.FC<CollapseProps> = props => {
  const {
    summary = "",
    children,
    open = false,
    arrow,
    className,
    style,
    onToggle,
    dataTrackId = "collapse",
    ...rest
  } = props;
  const detailRef = useRef<HTMLDivElement>(null);
  const [innerOpen, setInneropen] = useState(open);
  const handleOnchange = () => {
    setInneropen(old => !old);
  };

  const detailStyle = useMemo(() => {
    const style: React.CSSProperties = { height: 0 };
    if (innerOpen)
      style.height =
        process.env.TARO_ENV === "h5"
          ? `${detailRef.current?.scrollHeight}px`
          : "auto";
    process.env.TARO_ENV === "h5" &&
      innerOpen &&
      detailRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    onToggle?.(innerOpen);
    return style;
  }, [innerOpen]);

  return (
    <View
      className={classNames("xh-collapse", className)}
      style={style}
      // @ts-ignore
      dataTrackId={dataTrackId}
    >
      <View
        // @ts-ignore
        dataTrackId={`${dataTrackId}_summary`}
        className={classNames("xh-collapse-summary", { open: innerOpen })}
        onClick={handleOnchange}
      >
        {summary || (
          <List {...rest} arrow dataTrackId={`${dataTrackId}_summary_list`} />
        )}
      </View>
      <View
        className={classNames("xh-collapse-detail")}
        ref={detailRef}
        style={detailStyle}
      >
        {children}
      </View>
    </View>
  );
};

export default Collapse;
